import apiUrl from "./config/config";
import axios from "axios";

class translateApi {

  static async translateText(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "translate", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}

export default translateApi;
